export default __webpack_public_path__ + "static/media/car-solid-full.784909de.svg";